import { Typography } from 'antd';
import { CloseIcon, MinusCircleOutline } from 'assets';
import { Modal } from 'components/common';
import { customerLookupMessages } from 'messages/customer-lookup.message';
import React, { useEffect } from 'react';
import ContactDetails from './ContactDetails';
import ContactOverview from './ContactOverview';

type Props = {
  open: boolean;
  onClose: () => void;
  contactId?: number | null;
  searchCriteria?: any;
  handleCustomerCodeClick?: (customerCode: string) => void;
};

export enum CustomerLookupContactModalTab {
  CUSTOMERS = 'customers',
  IN_PROGRESS_TICKETS = 'in-progress-tickets',
  COMPLETE_TICKETS = 'complete-tickets',
  HISTORY = 'history'
}

const CustomerLookupContactModal = ({ open, onClose, contactId, searchCriteria, handleCustomerCodeClick }: Props) => {
  const [tabKey, setTabKey] = React.useState<CustomerLookupContactModalTab>(CustomerLookupContactModalTab.CUSTOMERS);

  useEffect(() => {
    if (!open) {
      setTabKey(CustomerLookupContactModalTab.CUSTOMERS);
    }
  }, [open]);

  return (
    <Modal
      style={{
        top: 45
      }}
      closable={false}
      styles={{
        body: {
          padding: 0,
          minHeight: 'calc(100vh - 90px)',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 12
        }
      }}
      width={'90vw'}
      footer={null}
      open={open}
      onClose={onClose}
      destroyOnClose={true}
    >
      <div className='flex h-16 items-center justify-between border-b bg-backgroundColor1 px-6'>
        <Typography.Text className='font-semibold'>{customerLookupMessages.contactInfo}</Typography.Text>
        <div onClick={onClose} className='flex h-8 w-8 cursor-pointer items-center justify-center'>
          <CloseIcon className='h-4 w-4' />
        </div>
      </div>
      {contactId && (
        <div className='flex h-full max-h-[calc(100%-64px)] flex-1 overflow-hidden'>
          <div className='flex w-[568px] bg-backgroundColor1'>
            <ContactDetails contactId={contactId} />
          </div>
          <div className='flex flex-1 border-r border-colorBorder bg-white'>
            <ContactOverview
              contactId={contactId}
              tabKey={tabKey}
              setTabKey={setTabKey}
              searchCriteria={searchCriteria}
              handleCustomerCodeClick={handleCustomerCodeClick}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default CustomerLookupContactModal;
